import { render, staticRenderFns } from "./CompleteConsultationComponent.vue?vue&type=template&id=1bc0f6fa&scoped=true"
import script from "./CompleteConsultationComponent.vue?vue&type=script&lang=ts"
export * from "./CompleteConsultationComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc0f6fa",
  null
  
)

export default component.exports